import React from "react";
import { useSelector } from "react-redux";
import { Formik, Field, Form } from "formik";
import { makeStyles } from "@material-ui/styles";
import validate from "./validate";
import MuiTextInput from "../../Common/MuiTextInput";
import { Button } from "@mantine/core";
import { getInfo } from "./util";

const useStyles = makeStyles({
  submit: {
    marginTop: "0.25rem",
  },
});

const PasswordForm = (props) => {
  const { handleSubmit, initialValues } = props;
  const { config, language } = useSelector((state) => ({
    config: state.infrastructure.config,
    language: state.language,
  }));
  const classes = useStyles();
  const info = getInfo(config.passwordRules);
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, actions) => handleSubmit(values, actions)}
      validate={(values) =>
        validate(values, language, config.passwordRules, info)
      }
      render={(props) => (
        <Form>
          <Field
            component={MuiTextInput}
            fullWidth={true}
            label={language.NewPassword}
            name="newPassword"
            placeholder={`${language.NewPassword} (${language.Required})`}
            type="password"
            info={info}
            required={true}
          />
          <Field
            component={MuiTextInput}
            fullWidth={true}
            label={language.ConfirmPassword}
            name="confirmPassword"
            placeholder={`${language.ConfirmPassword} (${language.Required})`}
            type="password"
            required={true}
          />
          <div className={classes.submit}>
            <Button
              disabled={!props.isValid || props.isSubmitting}
              type="submit"
              className="password__submit-button primaryButton"
              size="md"
            >
              {language.Save || "Spara"}
            </Button>
          </div>
        </Form>
      )}
    />
  );
};

export default PasswordForm;
